<template>
  <div>
    <narrowBanner/>
    <br/>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <nav class="breadcrumb is-small" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/">首頁</router-link></li>
              <li class="is-active"><router-link to="/resources" aria-current="page">相關資源</router-link></li>
            </ul>
          </nav>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="content">
          <h2 class="title is-size-4">{{ $prismic.richTextAsPlain(content.data.heading) }}</h2>
          <prismic-rich-text :field="content.data.content"/>
        </div>
      </div>
    </section>

    <br/>
  </div>
</template>

<script>
import narrowBanner from '@/components/narrowBanner.vue';

export default {
  name: 'about',
  components: {
    narrowBanner,
  },
  data() {
    return {
      content: [],
    };
  },
  methods: {
    getContent() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'resources'),
      ).then((response) => {
        [this.content] = response.results;
      });
    },

  },
  created() {
    this.getContent();
  },
};
</script>

<style lang="scss" scoped>
.hero-body {
  padding: 0.17rem 1.5rem;
}

.card-header-icon {
  & i {
    border: none;
  }
}

.card-footer {
  display: -webkit-box;
}
</style>
